import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { RADIO_PLAN_DESC } from '@app/core/models/Radio';
import { LiveTrackingState } from '@app/core/states/live-tracking.state';
import { RootBac } from '@app/library/models/bac.model';
import { BacsState } from '@app/library/states/bacs.state';
import { planBigger } from '@app/shared/utils';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'rk-box-filter',
  templateUrl: './box-filter.component.html',
  styleUrls: ['./box-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoxFilterComponent implements OnInit, OnDestroy {
  @Select(LiveTrackingState.planDesc)
  planDesc$: Observable<RADIO_PLAN_DESC>;

  bacsGroups$: Observable<RootBac[]>;

  allBox = '__ALL__';

  @Input()
  selectedBox: string;

  subscription = new Subscription();

  @Output()
  readonly selectBox = new EventEmitter<string>();

  constructor(private readonly store: Store) {}

  ngOnInit() {
    this.subscription.add(
      this.planDesc$.subscribe(plan => {
        this.bacsGroups$ = this.store
          .select(BacsState.bacsFiltered)
          .pipe(map(fn => fn(planBigger(plan, 'Demo'))));
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  planBigger(plan: RADIO_PLAN_DESC, compareTo: RADIO_PLAN_DESC) {
    return planBigger(plan, compareTo);
  }
}
